import {Object3D} from "three";
import Action from '../classes/Action';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import {CustomEventTypes, SaveModificationTypes} from '../globals';
import Scenario from '../classes/scenarioElements/Scenario';
import ProjectSaver from '../classes/ProjectSaver';
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";

@ActionDescription("Set the name of one or more objects")
@ActionParameters({objects: "Object3D[]", newNames: "string[]", oldNames: "string[]"})
@RegisterActionWithAPI("SetObjectNameAction")
export default class SetObjectNameAction extends Action
{
	constructor(objects: Object3D[], newNames: string[] | string, oldNames: string[])
	{
		if (!Array.isArray(newNames)) newNames = Array(objects.length).fill(newNames);
		const actionName = objects.length > 1 ? "Renamed Objects" : "Renamed " + oldNames[0] + " to " + newNames[0];
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, newNames, isDefaultState],
			[objects, oldNames, isDefaultState],
			actionName,
			[objects, newNames, oldNames]);
	}

	do(objects: Object3D[], names: string[], isDefaultState: boolean): void
	{
		if (isDefaultState) DefaultSceneManager.getInstance().syncNativeObjectProperty(objects, 'name', names);

		const oldNames : string[] = [];

		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			const oldName = object.name;
			oldNames.push(oldName);
			object.name = names[i];
			ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Name);
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectNameChanged, { detail: { sender: this, objects: objects, names: names, oldNames : oldNames } }));
	}

	verify(objects: Object3D[], newNames: string[], oldNames: string[]): boolean
	{
		if (objects.length === 0) return false;

		for (let i = 0; i < objects.length; i++)
		{
			if (oldNames[i] !== newNames[i])
			{
				return true;
			}
		}

		return false;
	}
}
